
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("aWG9Z", function(module, exports) {

$parcel$export(module.exports, "JqlUtils", () => $32ea0b04664d0d2d$export$2837dbdb4d803576);

var $6bXiw = parcelRequire("6bXiw");

var $kmBSv = parcelRequire("kmBSv");

var $gGGWz = parcelRequire("gGGWz");

var $5dPZE = parcelRequire("5dPZE");

var $fNGkN = parcelRequire("fNGkN");

var $iI9IQ = parcelRequire("iI9IQ");
class $32ea0b04664d0d2d$export$2837dbdb4d803576 {
    jql(newJqlString) {
        const newJast = new (0, $6bXiw.JastBuilder)().build(newJqlString);
        if (newJast.errors.length && this.jast) return this;
        this.jast = newJast;
        this.jqlString = newJqlString;
        return this;
    }
    ast(ast) {
        this.jast = ast;
        this.jqlString = ast.represents;
        return this;
    }
    setPrimarySortField(sortField, sortDirection, aliases) {
        if (!this.jast) return this;
        return this.jql((0, $iI9IQ.setPrimarySortField)(this.jast, sortField, sortDirection, aliases));
    }
    setPrimarySortDirection(sortOrder) {
        if (!this.jast) return this;
        return this.jql((0, $fNGkN.setPrimarySortDirection)(sortOrder, this.jast));
    }
    getPrimarySortField() {
        if (!this.jast) return undefined;
        return (0, $5dPZE.getPrimarySortField)(this.jast);
    }
    getPrimarySortDirection() {
        if (!this.jast) return undefined;
        return (0, $gGGWz.getPrimarySortDirection)(this.jast);
    }
    getOrderBy() {
        if (!this.jast) return undefined;
        return (0, $kmBSv.getOrderBy)(this.jast);
    }
    toJql() {
        return this.jqlString;
    }
    constructor(){
        this.jast = undefined;
        this.jqlString = undefined;
    }
}

});
parcelRegister("kmBSv", function(module, exports) {

$parcel$export(module.exports, "getOrderBy", () => $2560527d793aaaf6$export$128f09144c413f07);

var $4g5bl = parcelRequire("4g5bl");
const $2560527d793aaaf6$export$128f09144c413f07 = (jast)=>{
    const jqlString = jast.represents;
    const orderBy = jast.query?.orderBy;
    if (orderBy && orderBy.position) return (0, $4g5bl.substring)(jqlString, orderBy.position[0], orderBy.position[1]);
    return undefined;
};

});
parcelRegister("4g5bl", function(module, exports) {

$parcel$export(module.exports, "substring", () => $2d42e337a14476e7$export$662d3818631fba36);
/**
 * Returns the substring at the specified location within a String object while supporting Emojis.
 *
 * This method is to be used instead of String.substring. String.substring does not handle emojis correctly as they can be multi-char length.
 *
 * @param start — The zero-based index number indicating the beginning of the substring.
 * @param end Zero-based index number indicating the end of the substring. The substring includes the characters up to, but not including, the character indicated by end. If end is omitted, the characters from start through the end of the original string are returned.
 */ const $2d42e337a14476e7$export$662d3818631fba36 = (str, start, end)=>[
        ...str
    ].slice(start, end).join('');

});


parcelRegister("gGGWz", function(module, exports) {

$parcel$export(module.exports, "getPrimarySortDirection", () => $4cd76218ab78dd4a$export$ede1a70fd138682b);
const $4cd76218ab78dd4a$export$ede1a70fd138682b = (jast)=>jast.query?.orderBy?.fields[0]?.direction?.value;

});

parcelRegister("5dPZE", function(module, exports) {

$parcel$export(module.exports, "getPrimarySortField", () => $61dcf547c07ecaf5$export$2281286922a00968);

var $4g5bl = parcelRequire("4g5bl");
const $61dcf547c07ecaf5$export$2281286922a00968 = (jast)=>{
    const primarySortField = jast.query?.orderBy?.fields[0];
    return primarySortField?.field.properties && primarySortField?.field?.position ? (0, $4g5bl.substring)(jast.represents, primarySortField?.field?.position[0], primarySortField?.field?.position[1]) : primarySortField?.field.value;
};

});

parcelRegister("fNGkN", function(module, exports) {

$parcel$export(module.exports, "setPrimarySortDirection", () => $abcb17f2d50d6980$export$aec8b488d3f81589);

var $4g5bl = parcelRequire("4g5bl");
const $abcb17f2d50d6980$export$aec8b488d3f81589 = (sortOrder, jast)=>{
    const jql = jast.represents;
    const orderBy = jast.query?.orderBy;
    if (typeof jql !== 'string') return '';
    if (!orderBy || !orderBy.fields.length) return jql;
    const { direction: direction } = orderBy.fields[0];
    if (!direction && orderBy.fields.length > 1) {
        const { field: field } = orderBy.fields[0];
        if (!field.position) return jql;
        const [, end] = field.position;
        return `${(0, $4g5bl.substring)(jql, 0, end)} ${sortOrder}${(0, $4g5bl.substring)(jql, end)}`;
    }
    if (!direction) return `${jql} ${sortOrder}`;
    if (!direction.position) return jql;
    const [start, end] = direction.position;
    return `${(0, $4g5bl.substring)(jql, 0, start)}${sortOrder}${(0, $4g5bl.substring)(jql, end)}`;
};

});

parcelRegister("iI9IQ", function(module, exports) {

$parcel$export(module.exports, "setPrimarySortField", () => $7da01dafbbe2acc5$export$e66898f5eaced7d6);


var $4g5bl = parcelRequire("4g5bl");

var $iehtc = parcelRequire("iehtc");
const $7da01dafbbe2acc5$export$e66898f5eaced7d6 = (jast, sortField, sortDirection = (0, $bb912bd4cd77a1cf$export$2ea27ea5f2121899), aliases)=>{
    const orderBy = jast.query?.orderBy;
    const jql = jast.represents;
    if (!orderBy || !orderBy.fields.length) return `${jql} ORDER BY ${sortField}${sortDirection ? ` ${sortDirection}` : ''}`;
    const includedFields = new Set([
        sortField,
        ...aliases
    ]);
    const sanitizedSortField = (0, $iehtc.sanitizeClauseName)(sortField);
    const orderByFields = orderBy.fields;
    const fieldsJql = orderByFields// filter duplicates
    .filter((field)=>{
        const { position: position } = field.field;
        const fieldValue = field.field.properties && position ? (0, $4g5bl.substring)(jql, position[0], position[1]) : field.field.value;
        if (includedFields.has(fieldValue)) return false;
        includedFields.add(fieldValue);
        return true;
    })// convert fields to jql
    .reduce((acc, field)=>{
        const { position: position } = field;
        // acc.push(`${field.field.value} ${field.direction?.value || ''}`);
        if (position) acc.push((0, $4g5bl.substring)(jql, position[0], position[1]));
        return acc;
    }, [
        `${sanitizedSortField} ${sortDirection}`
    ]).join(', ');
    const startPosition = orderBy.fields[0].position;
    if (startPosition) {
        const start = startPosition[0];
        return `${(0, $4g5bl.substring)(jql, 0, start)}${fieldsJql}`;
    }
    return jql;
};

});
const $bb912bd4cd77a1cf$export$ca51f5fd60a74517 = 'ORDER BY';
const $bb912bd4cd77a1cf$export$6d60017b9e092e73 = 'ASC';
const $bb912bd4cd77a1cf$export$2ea27ea5f2121899 = 'DESC';

parcelRegister("iehtc", function(module, exports) {

$parcel$export(module.exports, "sanitizeClauseName", () => $b4e1612d86392091$export$5f3b8bbb2bff9817);

var $8Uuf0 = parcelRequire("8Uuf0");
// Check if string have inner spaces
const $b4e1612d86392091$var$haveSpaces = (s)=>/\s/g.test(s.trim());
const $b4e1612d86392091$export$5f3b8bbb2bff9817 = (clauseName)=>{
    if ($b4e1612d86392091$var$haveSpaces(clauseName)) return (0, $8Uuf0.quoteString)(clauseName);
    return clauseName;
};

});
parcelRegister("8Uuf0", function(module, exports) {

$parcel$export(module.exports, "quoteString", () => $10aface76faf85db$export$2c4c4d2119dc396f);
/**
 * Wrap the provided string in double quotes and escape and double quote characters present in the string.
 */ const $10aface76faf85db$export$2c4c4d2119dc396f = (str)=>`"${str.replace(/"/g, '\\"')}"`;

});





//# sourceMappingURL=async-jira-jql-utils.6b6adc26.js.map
